<template>
  <div class="pa-3" id="summary">
   <!--タイトル-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--内容-->
 <div class="row">
<v-col>
 <v-card-text class="summary" style="white-space:pre-wrap; word-wrap:break-word; margin-top:-1rem;">
                {{ description }}
          </v-card-text>
          </v-col>
</div>
</div>
</template>

<style>
.subHead {
  font-size: 25px;
}
.head2 {
  font-size: 20px;
  border-left: inset 6px#99CCFF;
  padding-left: 8px;
  margin-bottom: 8px;
}
.summary {
  vertical-align: middle;
  font-size: 16px;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '概要',
      // タイトル横のアイコン
      icon: 'mdi-message-bulleted',
      // 説明文
      description: `
オンライン演題登録では、フォームへのアブストラクトの入力、プロシーディングのファイル投稿が可能です。フォームへのアブストラクトの入力ではツールバーにより書式設定が行えます。オプションで部屋割り、時間割り、座長の割り当てが可能です。

査読システムではレビューアへの論文の割り振りから、アクセプト、リビジョン、リジェクトの一斉メール送信ができます。オプションで、レビューアが、名前や、所属機関を推測できる文言を削除した論文を査読する事が可能です。但し、所属機関や所属機関を推測できる文言の削除は手動で行う必要があります。

オンライン演題登録システム、査読システムともに学術集会の方針に合わせてカスタマイズを行います。 `
    }
  }
}
</script>
